import styled from 'styled-components';
import { addAlpha } from '@algoan/deep-dive/theme';

export const Divider = styled.div`
  width: 100%;
  border-top: 2px solid ${({ theme }) => addAlpha(theme.algoanBlue, 0.05)};
  margin-bottom: 24px;
`;
